export default __webpack_public_path__ + "61109ab26e5c18c7d8e07d001e338bc9.png";